__turbopack_context__.v({
  "accordionSlideOverwrite": "termSheetHeader-module-scss-module__m5EPua__accordionSlideOverwrite",
  "demoLink": "termSheetHeader-module-scss-module__m5EPua__demoLink",
  "fadeIn": "termSheetHeader-module-scss-module__m5EPua__fadeIn",
  "fadeOut": "termSheetHeader-module-scss-module__m5EPua__fadeOut",
  "fixed": "termSheetHeader-module-scss-module__m5EPua__fixed",
  "scaleIn": "termSheetHeader-module-scss-module__m5EPua__scaleIn",
  "scaleOut": "termSheetHeader-module-scss-module__m5EPua__scaleOut",
  "static": "termSheetHeader-module-scss-module__m5EPua__static",
  "termSheetHeader": "termSheetHeader-module-scss-module__m5EPua__termSheetHeader",
  "zoomIn": "termSheetHeader-module-scss-module__m5EPua__zoomIn",
  "zoomOut": "termSheetHeader-module-scss-module__m5EPua__zoomOut",
});
